<template>
  <BreadCrumb PageTitle="Liste des bons de paiments (Zones)" />
  <PaymentList />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import PaymentList from "@/components/Notes/Payments/Zone/PaymentList.vue";

export default defineComponent({
  name: "PaymentListPage",
  components: {
    BreadCrumb,
    PaymentList,
  },
});
</script>
